import React, { useState } from 'react';
import { Search } from 'lucide-react';
import { CollectorConfiguration } from './types';

const CollectorConfigurations = () => {
  const [searchTerm, setSearchTerm] = useState('');

  // Mock data - in real app, this would come from API
  const configurations: CollectorConfiguration[] = [];

  const filteredConfigurations = configurations.filter((config) => config.name.toLowerCase().includes(searchTerm.toLowerCase()));

  return (
    <div className="p-6">
      <h2 className="text-white text-xl font-semibold mb-6">Collector configurations</h2>

      {/* Search Bar and Add Button */}
      <div className="flex items-center justify-between mb-6">
        <button className="px-6 py-2 bg-[#D12929] hover:bg-[#b71c1c] text-white font-semibold rounded-lg transition-colors">
          Add New Collector Configuration
        </button>
        <div className="relative w-64">
          <Search className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={20} />
          <input
            type="text"
            placeholder="Search configurations..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full pl-4 pr-10 py-2 bg-[#1f1f1f] border border-[#474646] rounded-lg text-white placeholder-gray-400 focus:outline-none focus:border-[#D12929]"
          />
        </div>
      </div>

      {/* Table */}
      <div className="bg-[#1f1f1f] border border-[#474646] rounded-lg overflow-hidden">
        {/* Table Header */}
        <div className="grid grid-cols-4 gap-4 px-6 py-4 bg-[#2e2e2f] border-b border-[#474646]">
          <div className="text-gray-400 text-sm font-semibold">Collector Configuration Name</div>
          <div className="text-gray-400 text-sm font-semibold">Description</div>
          <div className="text-gray-400 text-sm font-semibold">Scope</div>
          <div className="text-gray-400 text-sm font-semibold">Created Date</div>
        </div>

        {/* Table Body */}
        {filteredConfigurations.length > 0 ? (
          <div>
            {filteredConfigurations.map((config, index) => (
              <div
                key={config.id}
                className={`grid grid-cols-4 gap-4 px-6 py-4 ${
                  index % 2 === 0 ? 'bg-[#1f1f1f]' : 'bg-[#2e2e2f]'
                } hover:bg-[#3a3a3b] transition-colors cursor-pointer`}
              >
                <div className="text-white text-sm">{config.name}</div>
                <div className="text-gray-300 text-sm">{config.description}</div>
                <div className="text-gray-300 text-sm">{config.scope}</div>
                <div className="text-gray-300 text-sm">{config.createdDate}</div>
              </div>
            ))}
          </div>
        ) : (
          <div className="px-6 py-12 text-center">
            <p className="text-gray-400 text-lg mb-2">No Rows To Show</p>
            <p className="text-gray-500 text-sm">
              {searchTerm
                ? 'No configurations match your search criteria.'
                : 'Click "Add New Collector Configuration" to create your first configuration.'}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default CollectorConfigurations;
